import { requestGet } from '@/common/request';

export interface getDetailByRoomIdParams {
  roomId?: string;
  activityId?: string;
}

export interface getDetailByRoomIdRes {
  ret: string;
  msg: string;
  data?: any;
}

//会场运营 - 根据会场活动 id 查询详情
export async function getDetailByRoomId(params: getDetailByRoomIdParams): Promise<getDetailByRoomIdRes> {
  return await requestGet('/room/getDetailByRoomId', params);
}
